
export default {
    dotMailerTracker: {
        areDotMailerEntriesLoadedSuccessfully: false,
        dotMailerTrackerApiMessage: '',
    },
    apiStatus: {
        apiCallsInProgress: 0,
        apiErrorMessages: []
    }
};
